import strings from '@/strings/en';

export default {
    install: function (Vue, options) {
        console.log('strings.options', options)
        Vue.prototype.$strings = function (key) {
            if (key.length === 0) {
                return key;
            }
            let currentNode = strings;
            let keys = key.split('/')
            for (let i = 0, len = keys.length; i < len; i++) {
                if (!Object.prototype.hasOwnProperty.call(currentNode, keys[i])) {
                    return '[not.in.strings]' + keys[i];
                }
                currentNode = currentNode[keys[i]]
            }
            return currentNode;
        }
    }
}